import { routeTree } from "@app/routeTree.gen.ts";
import { useAuthStore } from "@app/stores/useAuthStore.ts";
import {
  createRouter,
  type LinkProps,
  type RegisteredRouter,
} from "@tanstack/react-router";

export const appRouter = createRouter({
  routeTree,
  context: { isAuthenticated: false },
});

useAuthStore.subscribe((state, prev) => {
  if (state.user?.id !== prev.user?.id) {
    appRouter.invalidate().catch(() => null);
  }
});

export type AppRoutes = NonNullable<LinkProps<RegisteredRouter>["to"]>;

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof appRouter;
  }
}
